// extracted by mini-css-extract-plugin
export default {"footerBg":"Da-z","footerTopLinks":"Ea-z","footerFeedback":"Fa-z","footerSocial":"Ga-z","footerLegalLinks":"Ha-z","footerIconCards":"Ia-z","footerBotCopy":"Ja-z"};